import { render, staticRenderFns } from "./PriceUsageTable.vue?vue&type=template&id=28401bfa&scoped=true&"
import script from "./PriceUsageTable.vue?vue&type=script&lang=js&"
export * from "./PriceUsageTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceUsageTable.vue?vue&type=style&index=0&id=28401bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28401bfa",
  null
  
)

export default component.exports